/* MS 2026-09-30: Beszámítási kalkulátor — árlista a belső rendszerből (Supabase) + 50%-os állapotlogika.
   - Az árakat a belső rendszer Árazás füléről tölti be; ha ez nem sikerül, a kalkulátor a beégetett árakkal fut (régi logika).
   - Kapcsolók az adatbázisban (beszamitas_beallitas): arlista_db, uj_logika.
   - 50%-os logika: a nem törött állapot-levonások közül a legnagyobb teljesen, a többi 50%-ban számít;
     ha minden elem legfeljebb enyhén kopott (a 2. kategóriáig), csak a legnagyobb számít. Törött (iPhone) teljes, összeadódik. */
(function () {
  'use strict';
  if (window.__msArlista) return; window.__msArlista = true;
  var RPC = 'https://ptvmhcbtfzefsqzadmqr.supabase.co/rest/v1/rpc/beszamitas_arlista_json';
  var KEY = 'sb_publishable_Oi0FsBs5N2wxm4A9k1CS4w_75Le4VDn';
  var TOROTT = ['Törött, repedt', 'Hátlap törött'];
  var PRE = { iPhone: 'iphone', iPad: 'ipad', Watch: 'watch', MacBook: 'macbook' };
  window.msUjLogika = false;
  window.msMacNyelv = { us: -10000, usDraga: -20000, hatar: 400000 };

  function kesz() {
    try { return typeof modellek === 'object' && typeof valasztott === 'object' && typeof allapotok === 'object' && typeof mutasdAjanlatot === 'function'; } catch (e) { return false; }
  }
  function kap(s) { var m = /^(\d+(?:\.\d+)?)\s*(GB|TB)$/i.exec(s || ''); return m ? parseFloat(m[1]) * (m[2].toUpperCase() === 'TB' ? 1024 : 1) : 1e9; }
  function rendezKap(o) { if (!o || typeof o !== 'object') return o; var n = {}; Object.keys(o).sort(function (a, b) { return kap(a) - kap(b); }).forEach(function (k) { n[k] = o[k]; }); return n; }
  // kulcssorrend: a beégetett (referencia) objektum sorrendje, utána a többi érték szerint (0 elöl)
  function rendezRef(o, ref) {
    if (!o || typeof o !== 'object' || Array.isArray(o)) return o;
    var n = {}, ks = Object.keys(o), r = (ref && typeof ref === 'object') ? Object.keys(ref) : [];
    r.forEach(function (k) { if (ks.indexOf(k) >= 0) n[k] = rendezRef(o[k], ref[k]); });
    ks.filter(function (k) { return r.indexOf(k) < 0; })
      .sort(function (a, b) { return (typeof o[b] === 'number' && typeof o[a] === 'number') ? o[b] - o[a] : 0; })
      .forEach(function (k) { n[k] = rendezRef(o[k], null); });
    return n;
  }
  function egyenlo(a, b) {
    if (a === b) return true;
    if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return false;
    var ka = Object.keys(a), kb = Object.keys(b); if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) if (!egyenlo(a[ka[i]], b[ka[i]])) return false;
    return true;
  }
  function csere(cel, uj) { Object.keys(cel).forEach(function (k) { delete cel[k]; }); Object.keys(uj).forEach(function (k) { cel[k] = uj[k]; }); }

  function alkalmaz(d) {
    var b = d.beallitas || {};
    if (b.arlista_db === false) return;
    if (valasztott.modell) return; // már elkezdett kalkuláció közben nem cserélünk árat
    var regiModellek = {}; Object.keys(modellek).forEach(function (k) { regiModellek[k] = modellek[k]; });
    var uj = {};
    Object.keys(d.modellek || {}).forEach(function (nev) {
      var m = d.modellek[nev], ref = regiModellek[nev] || {};
      if (m.tarhely) m.tarhely = rendezKap(m.tarhely);
      if (m.tarhelyArak) m.tarhelyArak = rendezKap(m.tarhelyArak);
      if (m.watchFelarak) m.watchFelarak = rendezRef(m.watchFelarak, ref.watchFelarak);
      uj[nev] = m;
    });
    if (!Object.keys(uj).length) return;
    csere(modellek, uj);
    if (typeof iphoneAllapotArak === 'object') {
      var ia = {}, g1 = (typeof iphoneDeductionGroups === 'object' && iphoneDeductionGroups[1]) || null;
      Object.keys(d.iphoneAllapotArak || {}).forEach(function (nev) { ia[nev] = rendezRef(d.iphoneAllapotArak[nev], iphoneAllapotArak[nev] || g1); });
      csere(iphoneAllapotArak, ia);
    }
    [['iphoneDeductionGroups', typeof iphoneDeductionGroups === 'object' ? iphoneDeductionGroups : null],
     ['ipadDeductionGroups', typeof ipadDeductionGroups === 'object' ? ipadDeductionGroups : null],
     ['watchDeductionGroups', typeof watchDeductionGroups === 'object' ? watchDeductionGroups : null]].forEach(function (p) {
      var cel = p[1], src = d[p[0]]; if (!cel || !src) return;
      Object.keys(src).forEach(function (g) { cel[g] = rendezRef(src[g], cel[g]); });
    });
    if (typeof msMacArazas === 'object' && d.msMacArazas) {
      Object.keys(d.msMacArazas).forEach(function (nev) {
        if (egyenlo(d.msMacArazas[nev], msMacArazas[nev])) return;
        msMacArazas[nev] = d.msMacArazas[nev];
        try { if (typeof msMacBounds === 'object') delete msMacBounds[nev]; } catch (e) {} // módosított ár: a régi korlátok ne írják felül
      });
    }
    var mg = d.macDeductionGroups && d.macDeductionGroups['1'];
    if (mg) {
      ['kijelzo', 'keret', 'billentyuzet'].forEach(function (k) {
        var cel = allapotok['macbook_' + k]; if (!cel || !mg[k]) return;
        Object.keys(cel).forEach(function (o) { if (typeof mg[k][o] === 'number') cel[o].ar = mg[k][o]; });
      });
      try { if (typeof macHibak === 'object' && mg.egyeb) Object.keys(macHibak).forEach(function (o) { if (typeof mg.egyeb[o] === 'number') macHibak[o] = mg.egyeb[o]; }); } catch (e) {}
      if (mg.nyelv) window.msMacNyelv = { us: mg.nyelv['US Angol'] != null ? mg.nyelv['US Angol'] : -10000, usDraga: mg.nyelv['US Angol, drágább gépnél'] != null ? mg.nyelv['US Angol, drágább gépnél'] : -20000, hatar: mg.nyelv_hatar || 400000 };
    }
    window.msUjLogika = b.uj_logika !== false;
    window.msArlistaForras = 'db:' + (d.frissitve || '');
  }

  /* ---- 50%-os állapotlogika ---- */
  function levonas() {
    var v = valasztott, pre = PRE[v.kategoria] || 'iphone';
    var el = [['kijelzo', v.kijelzoNev, v.kijelzoAr || 0], ['keret', v.keretNev, v.keretAr || 0]];
    if (v.kategoria === 'MacBook') el.push(['billentyuzet', v.billentyuzetNev, v.billentyuzetAr || 0]);
    var osszes = el.reduce(function (s, e) { return s + e[2]; }, 0);
    if (!window.msUjLogika || el.some(function (e) { return e[2] <= -999999; })) return osszes;
    var torott = 0, ep = [];
    el.forEach(function (e) {
      if (TOROTT.indexOf(e[1]) >= 0) { torott += e[2]; return; }
      var obj = allapotok[pre + '_' + e[0]] || {};
      var sor = Object.keys(obj).sort(function (a, b) { return (obj[b].ar || 0) - (obj[a].ar || 0); });
      ep.push({ d: e[2], rang: sor.indexOf(e[1]) });
    });
    ep.sort(function (a, b) { return a.d - b.d; });
    var rossz = ep.length ? ep[0].d : 0;
    var tobbi = ep.slice(1).reduce(function (s, e) { return s + e.d; }, 0);
    var latszik = ep.some(function (e) { return e.rang >= 2; });
    return torott + rossz + (latszik ? Math.round(tobbi / 2 / 1000) * 1000 : 0);
  }
  window.msAllapotLevonas = levonas;
  var bent = false;
  // a meglévő függvények az állapot-levonásokat összeadják: híváskor ideiglenesen a számított értéket adjuk át
  function becsomagol(nev) {
    var eredeti = window[nev]; if (typeof eredeti !== 'function' || eredeti.__ms) return;
    var f = function () {
      if (bent) return eredeti.apply(this, arguments);
      var v = valasztott, k = v.kijelzoAr, r = v.keretAr, b = v.billentyuzetAr;
      v.kijelzoAr = levonas(); v.keretAr = 0; v.billentyuzetAr = 0; bent = true;
      try { return eredeti.apply(this, arguments); } finally { bent = false; v.kijelzoAr = k; v.keretAr = r; v.billentyuzetAr = b; }
    };
    f.__ms = true; window[nev] = f;
  }
  function nyelvJavitas() {
    var eredeti = window.checkMacVariaciok; if (typeof eredeti !== 'function' || eredeti.__ms) return;
    var f = function () {
      var x = eredeti.apply(this, arguments), v = valasztott, n = window.msMacNyelv;
      if (v.kategoria === 'MacBook' && v.macBillentyuzet === 'US Angol' && n) v.tarhelyAr = v.alapAr > n.hatar ? n.usDraga : n.us;
      return x;
    };
    f.__ms = true; window.checkMacVariaciok = f;
  }

  function indul() {
    if (!kesz()) return false;
    becsomagol('mutasdAjanlatot'); becsomagol('alkalmazKupon'); nyelvJavitas();
    var vezerlo = typeof AbortController === 'function' ? new AbortController() : null;
    var idozito = setTimeout(function () { if (vezerlo) vezerlo.abort(); }, 5000);
    fetch(RPC, { method: 'POST', headers: { 'Content-Type': 'application/json', apikey: KEY }, body: '{}', signal: vezerlo ? vezerlo.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { clearTimeout(idozito); try { alkalmaz(d); } catch (e) { window.msUjLogika = false; console.warn('[MS árlista] alkalmazás hiba, beégetett árak maradnak', e); } })
      .catch(function (e) { clearTimeout(idozito); console.warn('[MS árlista] nem elérhető, beégetett árak maradnak', e); });
    return true;
  }
  if (!indul()) { var t = 0, iv = setInterval(function () { if (indul() || ++t > 50) clearInterval(iv); }, 100); }
})();
